module.exports = __webpack_public_path__ + "img/bar-chart-08.7c2f94f2.svg";